export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/viewer/icon-setting-1be3f41f736d596a90fe21fd78436d02.svg";